"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function initMap() {
  const infoWindows = [];
  const denmark = { lat: 56.202790, lng: 10.250490 };
  const markerImage = window.settings.marker_image;
  const stores = window.settings.stores;
  const storeAddresses = [];
  const storeInfo = [];
  const storeListItem = document.querySelectorAll('.multicolumn-list__item')
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 7.5,
    center: denmark,
    navigationControl: false,
    scrollwheel: false,
    streetViewControl: true,
    styles: [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative.land_parcel", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "color": "#d1caca" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#c5bbba" }, { "lightness": "0" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{ "color": "#c5bbba" }] }, { "featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [{ "color": "#5c5c5c" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#5f5b5b" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#202121" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#202121" }, { "lightness": "0" }] }, { "featureType": "road.arterial", "elementType": "labels", "stylers": [{ "color": "#ffffff" }, { "visibility": "simplified" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#202121" }, { "lightness": "0" }] }, { "featureType": "road.local", "elementType": "labels", "stylers": [{ "visibility": "simplified" }, { "color": "#fffdfd" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#363637" }, { "lightness": 17 }] }]
  });

  // Autocomplete widget
  const input = document.getElementById('store_search_input');
  const clearInput = document.getElementById('store_search_input-clear')
  const options = {
    types: ['address'],
    strictBounds: false,
    componentRestrictions: {'country': ['DK']},
    fields: ['formatted_address', 'geometry', "name"]
  };
  const autocomplete = new google.maps.places.Autocomplete(input, options);
  autocomplete.addListener("place_changed", () => {
    
    const place = autocomplete.getPlace();

    // Distance Matrix request
    let origin = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng() );
    let service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: storeAddresses,
        travelMode: 'DRIVING',
        avoidHighways: false,
        avoidTolls: false,
      }, getDistanceToOrigin);

    function getDistanceToOrigin(response, status) {
      if (status == 'OK') {
        let origins = response.originAddresses;
        let destinations = response.destinationAddresses;
    
        for (let i = 0; i < origins.length; i++) {
          let results = response.rows[i].elements;
          for (let j = 0; j < results.length; j++) {
            let element = results[j];
            let distance = element.distance.text;
            let duration = element.duration.text;
            let from = origins[i];
            let to = destinations[j];
          }
        } 
      }

      // Sort stores by distance to user input
      const sortedStores = []
      stores.forEach(store => {
        sortedStores.push({
          "streetAddress": response.destinationAddresses[stores.indexOf(store)].split(', ')[0],
          "distance": response.rows[0].elements[stores.indexOf(store)].distance.text,
          "value": response.rows[0].elements[stores.indexOf(store)].distance.value
        })
      })

      sortedStores.sort(function(a, b) {
        let keyA = a.value,
        keyB = b.value;
        if (keyA < keyB) return -1;
        return 0
      });

      // Display only the closest showroom section block
      const closestAddress = sortedStores[0].streetAddress
      storeListItem.forEach(item => {
        if (!item.innerText.includes(closestAddress) && !item.closest('.multicolumn').innerText.includes(closestAddress)) {
          item.closest('.multicolumn').style.display = 'none';
        } else if (!item.innerText.includes(closestAddress) && item.closest('.multicolumn').innerText.includes(closestAddress)) {
          item.style.display = 'none';
        } else {
          item.style.display = 'block';
          item.closest('.multicolumn').style.display = 'block';
          item.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
      }) 

      // Reset showroom cards on input clear
      clearInput.addEventListener('click', () => {
        input.value = "";
        storeListItem.forEach(item => {
          item.style.display = 'block';
          item.closest('.multicolumn').style.display = 'block';
        })
      })
    }
  });

  let nrOfTries;


  if (stores.length > 0) {
    stores.map(store => {
      nrOfTries = 1000;
      const storeName = store.store_name ? store.store_name : '';
      const storeAddress = store.store_address ? store.store_address : '';
      const storeInfo = store.store_info ? store.store_info : '';
      const storeLink = store.store_link ? store.store_link : null;
      const storeLocation = store.location ? store.location : null;

      storeAddresses.push(storeAddress);

      let storeLinkHTML = '';
      if(storeLink) {
        storeLinkHTML = '<a href="' + storeLink + '">Læs mere</a>';
      }
      const contentString = '<div class="map-card"><b class="map-header">' + storeName + '</b><br />' + storeAddress + '<br />' + storeInfo + '<br /><br />' + storeLinkHTML +'</div>';
      

      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 300
      });

      infoWindows.push(infowindow);

      if(storeLocation) {
        const latLng = {
          lat: parseFloat(storeLocation.split(',')[0].replace("(", "")),
          lng: parseFloat(storeLocation.split(',')[1].replace(")", ""))
        };

        const marker = new google.maps.Marker({
          position: latLng,
          map,
          icon: markerImage
        });
  
        marker.addListener("click", () => {
          if (isInfoWindowOpen(infowindow)) {
            if (infowindow.anchor != marker) {
              closeAllInfoWindows(infoWindows);
              infowindow.open(map, marker);
            } else {
              infowindow.close();
            }
          } else {
            closeAllInfoWindows(infoWindows);
            infowindow.open(map, marker);
          }
        });
      }
    });
  }
}

function isInfoWindowOpen(infowindow) {
  var map = infowindow.getMap();
  return (map !== null && typeof map !== "undefined");
}

function closeAllInfoWindows(infoWindows) {
  for (var i = 0; i < infoWindows.length; i++) {
    infoWindows[i].close();
  }
}

window.initMap = setTimeout(initMap, 200);